import { Button, Modal, Spinner, Table } from "@amzn/awsui-components-react";
import React from "react";
import { useMapReleaseStore } from "../../store/MapReleaseStore";
import { reformatBedrockSummary } from "../../utils/mapReleaseDashboard/mapReleaseDataUtils";


export interface Station {
    stationCode: string;
    country_code: string;
    total_time_delta_percent_avg: number;
    overall_tt_breached: boolean;
    stem_tt_breached: boolean;
}

const breachedStationsColumnDefinition = [
  {
    id: "stationCode",
    header: "Station Code",
    cell: (item: Station) => item.stationCode
  },
  {
    id: "countryCode",
    header: "Country Code",
    cell: (item: Station) => item.country_code
  },
  {
    id: "total_TT_delta_percent_avg",
    header: "Total TT Delta Percentage Average",
    cell: (item: Station) => item.total_time_delta_percent_avg
  },
  {
    id: "overall_tt_breached",
    header: "Overall TT Breached",
    cell: (item: Station) => item.overall_tt_breached ? "true" : "false"
  },
  {
    id: "stem_tt_breached",
    header: "Stem TT Breached",
    cell: (item: Station) => item.stem_tt_breached ? "true" : "false"
  }
]
  
const MapReleaseModal = ({bedrockPrompt, mapPackVersion}: {bedrockPrompt: string, mapPackVersion: string}) => {
    const handleDownload = () => {
        if (!summary) return;
        
        
        const fileContent = summary;
        const blob = new Blob([fileContent], { type: "text/plain" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.download = "bedrock_validation_summary.txt";
        link.href = url;
        link.click();
        
        if (stations && stations.length > 0) {
            let csvContent = "Station Code,Country Code,Total TT Delta Percentage Average,Overall TT Breached,Stem TT Breached\n";
            stations.forEach((station: Station) => {
                csvContent += `${station.stationCode},${station.country_code},${station.total_time_delta_percent_avg},${station.overall_tt_breached},${station.stem_tt_breached}\n`;
            });
            setTimeout(() => {
                const blobCSV = new Blob([csvContent], { type: "text/csv" });
                const urlCSV = URL.createObjectURL(blobCSV);
                const linkCSV = document.createElement("a");
                linkCSV.download = "breached_stations.csv";
                linkCSV.href = urlCSV;
                linkCSV.click();
                URL.revokeObjectURL(urlCSV);
            }, 100);
        }

        URL.revokeObjectURL(url);
    }
    const [isModalVisible, setModalVisible] = React.useState(false);
    
    const summary = useMapReleaseStore(
        (state) => state.getMapPackBedrockSummary()
    );
    const stations = useMapReleaseStore(
        (state) => state.getMapPackBedrockStations()
    );
    const fetchBedrockSummary = useMapReleaseStore(
        (state) => state.fetchMapPackBedrockSummary
    );
    const isMapPackBedrockLoaded = useMapReleaseStore(
        (state) => state.isMapPackBedrockLoaded()
    );
    const isMapPackBedrockInvalid = useMapReleaseStore(
        (state) => state.getInvalidMapPackBedrockSummary()
    );
    
    const handleViewBedrockSummary = () => {
        setModalVisible(true);
        fetchBedrockSummary(bedrockPrompt, mapPackVersion);
    }
    return (
    <>
        <Button iconName="folder" onClick={handleViewBedrockSummary} wrapText={false}>
            View Summary
        </Button>
        <Modal
            visible={isModalVisible}
            onDismiss={() => setModalVisible(false)}
            header="Validation Summary"
            size="max"
            footer={
                <span className="awsui-util-f-r">
                    <Button variant="link" onClick={() => setModalVisible(false)}>
                        Close
                    </Button>
                </span>
            }
        >
            {(isMapPackBedrockInvalid ? <div> Error with retrieving LLM summary </div>
            : (!isMapPackBedrockLoaded ? (["Loading... Summary generation in progress", <br/>, <Spinner size="normal" />]) 
            : summary ? ( 
                <div>
                <pre style={{ margin: 0, textAlign: 'left',  whiteSpace: 'pre-wrap', wordBreak: 'break-word', maxWidth: '100%', overflow: 'auto' }}>
                    {summary}
                </pre>
                
                {stations.length > 0 &&
                <Table
                    columnDefinitions={breachedStationsColumnDefinition}
                    items={stations}
                    header={<h2>
                        Breached Stations
                    </h2>}
                    empty={<div className="awsui-util-t-c">
                    <div className="awsui-util-pt-xs awsui-util-mb-xs">
                        <b>
                        Empty resources
                        </b>
                    </div>
                    <p className="awsui-util-mb-s">
                        No resources to display
                    </p>
                    </div>}
                    ></Table>
                }
                <br></br>
                <Button onClick={handleDownload} variant="normal" iconName="download">
                    Download Summary
                </Button>
                </div>
            )
            : ("No validation summary available") 
            ))}
        </Modal>
    </>
);
}

export default MapReleaseModal;
